import {withRouter} from 'react-router';

import {EventReportIncidentForm} from '@modules/events/forms/EventReportIncidentForm';
import {withApollo} from 'react-apollo';
import {refetchQueryByName} from '@utils/apollo';
import {INCIDENT_DURATION_UNIT_MINUTE} from '@constants/variables';

export class EventReportIncidentAddForm extends EventReportIncidentForm {
    componentDidMount() {
        super.componentDidMount();
        this.setCreateSuccessCallback(() => {
            refetchQueryByName('ReportState');
        });
    }

    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);

        const {GraphQLOptionsData: {incidentDurationUnits}, formValues} = this.props;

        if (incidentDurationUnits !== prevProps.GraphQLOptionsData.incidentDurationUnits) {
            this.setIncidentDurationField(incidentDurationUnits, formValues.entire_duration, INCIDENT_DURATION_UNIT_MINUTE);
        }
    }
}

export default withRouter(withApollo(EventReportIncidentAddForm));
